import { helpers, maxLength, required } from '@vuelidate/validators';

export function requiredRule(func = required) {
    return {
        required: helpers.withMessage('Поле должно быть заполнено', func),
    };
}

export function maxLengthRule(n = 100) {
    return {
        maxLength: helpers.withMessage(`Длина должна быть не более ${ n } символов`, maxLength(n)),
    };
}
